var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{style:({color: _vm.color})},[_c('i',{staticClass:"fal",class:("fa-" + _vm.name)})])}
var staticRenderFns = []

export { render, staticRenderFns }